import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NumberOrderPipe } from './number-order.pipe';
import { LeadingZeroPipe } from './leading-zero.pipe';



@NgModule({
    declarations: [
        NumberOrderPipe,
        LeadingZeroPipe
    ],
  exports: [
    NumberOrderPipe,
    LeadingZeroPipe
  ],
    imports: [
        CommonModule
    ]
})
export class PipesModule { }
